export default "__VITE_ASSET__C$h5n7tU__"